import { render, staticRenderFns } from "./ChecklistVideoEmbedModal.vue?vue&type=template&id=1a39b4c0"
import script from "./ChecklistVideoEmbedModal.vue?vue&type=script&lang=js"
export * from "./ChecklistVideoEmbedModal.vue?vue&type=script&lang=js"
import style0 from "./ChecklistVideoEmbedModal.vue?vue&type=style&index=0&id=1a39b4c0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a39b4c0')) {
      api.createRecord('1a39b4c0', component.options)
    } else {
      api.reload('1a39b4c0', component.options)
    }
    module.hot.accept("./ChecklistVideoEmbedModal.vue?vue&type=template&id=1a39b4c0", function () {
      api.rerender('1a39b4c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/checklists/ChecklistVideoEmbedModal.vue"
export default component.exports